module.exports = __webpack_public_path__ + "img/36376804000137.6ccb6a15.png";